import * as React from "react";
const SvgFlagIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m65.617 1167.3c0 18.07-14.676 32.797-32.809 32.797-18.133-0.003906-32.809-14.738-32.809-32.797v-1141.3c0-18.121 14.676-32.809 32.809-32.809 18.133 0 32.809 14.688 32.809 32.809z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m65.617 47.102h140.61v140.59h-140.61z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m205.87 187.34h140.57v140.61h-140.57z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m65.617 327.56h140.61v140.61h-140.61z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m205.87 467.83h140.57v140.59h-140.57z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m346.44 47.102h140.57v140.59h-140.57z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m486.76 187.34h140.51v140.61h-140.51z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m346.44 327.56h140.57v140.61h-140.57z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m486.76 467.83h140.51v140.59h-140.51z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m627.27 47.102h140.65v140.59h-140.65z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m767.59 187.34h140.55v140.61h-140.55z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m627.27 327.56h140.65v140.61h-140.65z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m767.59 467.83h140.55v140.59h-140.55z", style: {
  fill: "#001F54"
} }), /* @__PURE__ */ React.createElement("path", { d: "m939.93 640.08h-923.03v-621.73h923.03zm-891.21-31.785h859.43v-558.13h-859.43z", style: {
  fill: "#001F54"
} }));
export default SvgFlagIcon;
